module.exports = __webpack_public_path__ + "img/no-image-available-animation.4ffbb493.gif";